module.exports = __webpack_public_path__ + "img/galeria-ornamentais-3.907eceef.jpg";